import request from '@aned/request';

// 查询装载率详情
export async function search_day(params) {
  return request('/api/route/loadingRatio/sectionLoadRate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 分段装载率详情导出
export async function sectionLoadRateExport(params) {
  return request('/api/route/loadingRatio/sectionLoadRate/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}


// 查询合计
export async function aggregate(params) {
  return request('/api/route/loadingRatio/search_day/sectionAggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

/**
 *
 */

export async function search_week(params) {
  return request('/api/route/loadingRatio/search_week', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function weekAggregate(params) {
  return request('/api/route/loadingRatio/search_week/aggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function weekExport(params) {
  return request('/api/route/loadingRatio/search_week/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function search_month(params) {
  return request('/api/route/loadingRatio/search_month', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function monthAggregate(params) {
  return request('/api/route/loadingRatio/search_month/aggregate', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

export async function monthExport(params) {
  return request('/api/route/loadingRatio/search_month/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}

// 实时装载率
export async function realTime(params) {
  return request('/api/route/loadingRatio/real_time', {
    method: 'POST',
    body: params,
    reqType: 'json',
    // module: 'route',
  });
}
